<div class="pdf-container">
  <<iframe class="ifram" [src]="getPdf(cA)"></iframe>
</div>
